export { ListComponent } from './list/list.component';
export { ViewComponent } from './view/view.component';
export { EditComponent } from './edit/edit.component'
